// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"804263ca","866":"5bfe3752"}[chunkId] + ".chunk.js";
};